import { render, staticRenderFns } from "./EditUserRolesModal.vue?vue&type=template&id=355723b4&"
import script from "./EditUserRolesModal.vue?vue&type=script&lang=js&"
export * from "./EditUserRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports